export const ACTIVE_LOCATION_STORAGE_KEY = 'activeLocation'
export const ACTIVE_LOCATION_COOKIE_NAME = 'active_location'
export const ACTIVE_LOCATION_COOKIE_MAX_AGE = 60 * 60 * 24 * 30
